import { graphql } from '@lib/graphql'
import { execute } from '@lib/graphql/execute'
import { CustomerPasswordResetTokenInput } from '@lib/graphql/graphql'
import { MutationConfig } from '@lib/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getCustomerQueryOptions } from './get-customer'

export const customerPasswordResetTokenMutationDocument = graphql(`
  mutation CustomerPasswordResetToken(
    $input: CustomerPasswordResetTokenInput!
  ) {
    customerPasswordResetToken(input: $input) {
      errors {
        __typename
      }
    }
  }
`)

export const customerPasswordResetToken = (
  input: CustomerPasswordResetTokenInput,
) => {
  return execute(customerPasswordResetTokenMutationDocument, {
    input,
  })
}

type UseCustomerPasswordResetTokenOptions = {
  mutationConfig?: MutationConfig<typeof customerPasswordResetToken>
}

export const useCustomerPasswordResetToken = ({
  mutationConfig,
}: UseCustomerPasswordResetTokenOptions = {}) => {
  const queryClient = useQueryClient()

  const { onSuccess, ...restConfig } = mutationConfig || {}

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: getCustomerQueryOptions().queryKey,
      })
      onSuccess?.(...args)
    },
    ...restConfig,
    mutationFn: customerPasswordResetToken,
  })
}
